module.exports = __webpack_public_path__ + "static/img/csv-file-format.7e8899c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/document/csv-file-format.png
// module id = Wv/0
// module chunks = 4